export default __webpack_public_path__ + "static/media/master.a2920af7.png";